import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { key: String, url: String }

  connect() {
    if (this.isDismissed) {
      this.element.remove()
    }
  }

  dismiss() {
    this.element.style.transition = "opacity 150ms ease, transform 150ms ease"
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-8px)"

    localStorage.setItem(this.storageKey, "true")

    if (this.hasUrlValue) {
      fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })
    }

    this.element.addEventListener("transitionend", () => {
      this.element.remove()
    }, { once: true })
  }

  get isDismissed() {
    return localStorage.getItem(this.storageKey) === "true"
  }

  get storageKey() {
    return `opentil_${this.keyValue}_dismissed`
  }
}
